import * as AnalyticsModels from './analytics.model';
import * as ApiTokenModels from './api-token.model';
import * as AuthModels from './auth.model';
import * as ConfigModels from './config.model';
import * as CustomModels from './custom.model';
import * as DashboardModels from './dashboard.model';
import * as DictionaryModels from './dictionary.model';
import * as DirectoryModels from './directory.model';
import * as EmailProviderEventModels from './email-provider-event.model';
import * as EntitiesModels from './entities.model';
import * as GoogleApiModels from './google-api.model';
import * as HelpersModels from './helpers.model';
import * as HistoryModels from './history.model';
import * as ManagerModels from './manager.model';
import * as MetadataModels from './metadata.model';
import * as MysqlModels from './mysql.model';
import * as NotificationModels from './notification.model';
import * as OperatorModels from './operator.model';
import * as ProfileModels from './profile.model';
import * as RecruiterModels from './recruiter.model';
import * as ShortListModels from './short-list.model';
import * as SimpleSearchModels from './simple-search.model';
import * as VacancyModels from './vacancy.model';

export namespace API {
  export import Analytics = AnalyticsModels;
  export import ApiToken = ApiTokenModels;
  export import Auth = AuthModels;
  export import Config = ConfigModels;
  export import Custom = CustomModels;
  export import Dashboard = DashboardModels;
  export import Dictionary = DictionaryModels;
  export import Directory = DirectoryModels;
  export import EmailProviderEvent = EmailProviderEventModels;
  export import Entities = EntitiesModels;
  export import GoogleApi = GoogleApiModels;
  export import Helpers = HelpersModels;
  export import History = HistoryModels;
  export import Manager = ManagerModels;
  export import Metadata = MetadataModels;
  export import Mysql = MysqlModels;
  export import Notification = NotificationModels;
  export import Operator = OperatorModels;
  export import Profile = ProfileModels;
  export import Recruiter = RecruiterModels;
  export import ShortList = ShortListModels;
  export import SimpleSearch = SimpleSearchModels;
  export import Vacancy = VacancyModels;
}
